import { ModelCard, RunRow } from '../../../shared/services/api/models/band-studio.model';
import { runsNewestFirst } from './band-studio-display';

/** Route of the Models page; every Bands Studio link starts here. */
export const MODELS_ROUTE = '/pricing/models';

/** Router commands for a model's page: its draft, or the model itself. */
export function summaryCommands(slug: string, draft?: 'draft' | null): string[] {
  return draft === 'draft' ? [MODELS_ROUTE, slug, 'draft'] : [MODELS_ROUTE, slug];
}

/**
 * The page of a model's newest run, read across every card since a group can hold models of
 * another slug; null when the model never ran.
 */
export function newestRunCommands(slug: string, models: readonly ModelCard[]): string[] | null {
  const newest = runsNewestFirst(
    models.flatMap((m) => m.runs).filter((r) => r.slug === slug && !r.draft)
  )[0];
  return newest ? runSummaryCommands(slug, newest.run_id) : null;
}

/** Router commands for the summary of one model run: the logic that run ran, whatever it was. */
export function runSummaryCommands(slug: string, runId: string): string[] {
  return [MODELS_ROUTE, slug, 'run', runId];
}

/** Where a model opens: the draft page while it is a draft, else its own page. */
export function runOpenCommands(slug: string, run: RunRow): string[] {
  return run.draft ? summaryCommands(slug, 'draft') : runSummaryCommands(slug, run.run_id);
}
